/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.ProfessorRpc
 */
import * as References from './ProfessorRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.ProfessorRpc#getProfessor
 */
export const GET_PROFESSOR_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_ProfessorRpc_getProfessor';
export const GET_PROFESSOR_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROFESSOR_QUERY_FIELD_NAME,
  args: ['professorId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProfessorRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.ProfessorRpc#getProfessors
 */
export const GET_PROFESSORS_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_ProfessorRpc_getProfessors';
export const GET_PROFESSORS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROFESSORS_QUERY_FIELD_NAME,
  args: ['professorIds'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getProfessorsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});